const MainContainer = () => import('~/components/layouts/MainContainer').then(m => m.default || m)

const moduleRoutes = {
	path: '/affiliate',
	name: 'AffiliateIndex',
	redirect: '/affiliate',
	component: MainContainer,
	props: true,
	children: [
		{
			path: '',
			name: 'affiliate',
			component: () => import('./affiliate').then(m => m.default || m),
			meta: {
				pageTitle: 'My Affiliate Links',
				breadcrumbs: [{ title: 'My Affiliate Links', active: true }],
			},
		},
	],
}

export default moduleRoutes
